import { useContext, useMemo } from 'react'

import { useSession } from 'next-auth/react'

import { UserCustomerTypeEnum } from '@/gen/ecom-asm'
import { AsmSessionContext } from '@/providers/AsmSessionContextProvider'
import { useIsLoggedIn } from './useIsLoggedIn'

export function useAsmSession() {
  const isLoggedIn = useIsLoggedIn()
  const { data: session } = useSession()
  const { impersonatedUser } = useContext(AsmSessionContext)

  const employee = useMemo(
    () => !!session && session?.user?.customerType === UserCustomerTypeEnum.Employee.toLowerCase(),
    [session]
  )
  const impersonatedSession = useMemo(() => employee && impersonatedUser !== null, [employee, impersonatedUser])

  return {
    isLoggedIn,
    session,
    impersonatedUser,
    employee,
    impersonatedSession,
    isAuthorized: (isLoggedIn && !employee) || impersonatedSession,
  }
}
